/*
 * jquery.zeroclipboard
 * https://github.com/zeroclipboard/jquery.zeroclipboard
 *
 * Copyright (c) 2014 James M. Greene
 * Licensed under the MIT license.
 */

(function ($, window) {
  var mouseEnterBindingCount = 0,
    customEventNamespace = '.zeroclipboard',
    ZeroClipboard = window.ZeroClipboard,
    _trustedDomains = ZeroClipboard.config('trustedDomains');

  function getSelectionData () {
    var range,
      selectedText = '',
      selectedData = {},
      sel = window.getSelection(),
      tmp = document.createElement('div');

    for (var i = 0, len = sel.rangeCount; i < len; i++) {
      range = sel.getRangeAt(i);
      selectedText += range.toString();
      tmp.appendChild(range.cloneContents());
    }

    selectedData['text/plain'] = selectedText;
    if (selectedText.replace(/\s/g, '')) {
      selectedData['text/html'] = tmp.innerHTML;
    }

    return selectedData;
  }

  function zcEventHandler (e) {
    var $event = $.Event(e.type, $.extend(e, { '_source': 'swf' }));
    $(e.target).trigger($event);

    if ($event.type === 'copy') {
            // If `$event.preventDefault();` was not called...
      if (
                $.event.special.copy.options.requirePreventDefault === true &&
                !$event.isDefaultPrevented()
            ) {
                // Clear out any pending data
        e.clipboardData.clearData();

                // And then copy the currently selected text instead, if any
        var selectionData = getSelectionData();
        if (selectionData['text/plain'] || selectionData['text/html']) {
          e.clipboardData.setData(selectionData);
        }
      }
    }
  }

  function zcErrorHandler (e) {
    var $event = $.Event('copy-error', $.extend(e, { 'type': 'copy-error', '_source': 'swf' }));
    $(e.target).trigger($event);
  }

  function setup () {
    $.event.props.push('clipboardData');

    ZeroClipboard.config($.extend(true, { autoActivate: false }, copyEventDef.options));
    ZeroClipboard.on('copy', zcEventHandler);
    ZeroClipboard.on('error', zcErrorHandler);
    ZeroClipboard.create();
  }

  function teardown () {
    ZeroClipboard.destroy();

    var indy = $.event.props.indexOf('clipboardData');
    if (indy !== -1) {
      $.event.props.splice(indy, 1);
    }
  }

  function mouseSuppressor ($event) {
    if (!ZeroClipboard.isFlashUnusable() && $event.originalEvent._source !== 'js') {
      $event.stopImmediatePropagation();
      $event.preventDefault();
    }
  }

  var copyEventDef = {

        /* Invoked each time this event is bound */
    add: function (handleObj) {
            // If this is the first 'beforecopy'/'copy' binding on the page, we need to configure and create ZeroClipboard
      if (mouseEnterBindingCount++ === 0) {
        setup();
      }

      var namespaces = customEventNamespace + (handleObj.namespace ? '.' + handleObj.namespace : ''),
        selector = handleObj.selector,
        zcDataKey = 'zc|{' + selector + '}|{' + namespaces + '}|count',
        $this = $(this);

      if (typeof $this.data(zcDataKey) !== 'number') {
        $this.data(zcDataKey, 0);
      }

            // if ($this.data(zcDataKey) === 0) {
            //    $this.on("click" + namespaces, selector, mouseSuppressor);
            // }
            //
      $this.data(zcDataKey, $this.data(zcDataKey) + 1);
    },

        /* Invoked each time this event is unbound */
    remove: function (handleObj) {
      var namespaces = customEventNamespace + (handleObj.namespace ? '.' + handleObj.namespace : ''),
        selector = handleObj.selector,
        zcDataKey = 'zc|{' + selector + '}|{' + namespaces + '}|count',
        $this = $(this);

      $this.data(zcDataKey, $this.data(zcDataKey) - 1);

      if ($this.data(zcDataKey) === 0) {
        $this.off('click' + namespaces, selector, mouseSuppressor);

        $this.removeData(zcDataKey);
      }

            // If this is the last 'beforecopy'/'copy' unbinding on the page, we should also destroy ZeroClipboard
      if (--mouseEnterBindingCount === 0) {
        teardown();
      }
    },

        /* Invoked each time a manual call to `trigger`/`triggerHandler` is made for this event type */
    trigger: function ($event /*, data */) {
      if ($event.type === 'copy') {
        var $this = $(this);

        var sourceIsSwf = $event._source === 'swf';
        delete $event._source;

        if (!sourceIsSwf) {
                    // Then allow this 'copy' event to be handled...

                    // Then add a one-time handler for 'copy' to trigger an 'aftercopy' event
          $this.one('copy', function (/* $copyEvent */) {
                        // Mark all statuses as failed since we can't inject into the clipboard during a simulated event
            var successData = {},
              _clipData = ZeroClipboard.getData();
            $.each(_clipData, function (key /*, val */) {
              successData[key] = false;
            });
          });
        }
      }
    },

        /* Invoked each time this event type is about to dispatch its default action */
    _default: function (/* $event, data */) {
            // Prevent the element's default method from being called.
      return true;
    },

        /* Add some default configuration options that can be overridden */
    options: {

            // The default action for the W3C Clipboard API spec (as it stands today) is to
            // copy the currently selected text [and specificially ignore any pending data]
            // unless `e.preventDefault();` is called.
      requirePreventDefault: true,

            // SWF inbound scripting policy: page domains that the SWF should trust.
            // (single string, or array of strings)
      trustedDomains: _trustedDomains

    }

  };

    /* Leverage the jQuery Special Events API to expose these events in a seemingly more natural way */
  $.event.special.copy = copyEventDef;
})(jQuery, window);
